/* tslint:disable */
/* eslint-disable */
/**
 * ISO Backend Modules API
 * ISO API for the IBE.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ApiDocumentType;
(function (ApiDocumentType) {
    ApiDocumentType["INVOICE"] = "INVOICE";
    ApiDocumentType["CONFIRMATION"] = "CONFIRMATION";
    ApiDocumentType["OPTIONCONFIRMATION"] = "OPTION_CONFIRMATION";
    ApiDocumentType["ITINERARY"] = "ITINERARY";
    ApiDocumentType["PRRLTRAVELPLAN"] = "PRRL_TRAVEL_PLAN";
    ApiDocumentType["PRECONTRACTUAL"] = "PRECONTRACTUAL";
    ApiDocumentType["BOOKINGPROMOTIONVOUCHER"] = "BOOKING_PROMOTION_VOUCHER";
    ApiDocumentType["VOUCHER"] = "VOUCHER";
    ApiDocumentType["INVOICECOMPENSATION"] = "INVOICE_COMPENSATION";
    ApiDocumentType["EXTDOCUMENT"] = "EXT_DOCUMENT";
    ApiDocumentType["QUOTATION"] = "QUOTATION";
    ApiDocumentType["BOOKINGNUMBERLIST"] = "BOOKING_NUMBER_LIST";
    ApiDocumentType["ETIX"] = "ETIX";
    ApiDocumentType["REGISTRATIONFORM"] = "REGISTRATIONFORM";
    ApiDocumentType["UNKNOWN"] = "UNKNOWN";
})(ApiDocumentType || (ApiDocumentType = {}));
function ApiDocumentTypeFromJSON(json) {
    return ApiDocumentTypeFromJSONTyped(json);
}
function ApiDocumentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ApiDocumentTypeToJSON(value) {
    return value;
}

export { ApiDocumentType, ApiDocumentTypeFromJSON, ApiDocumentTypeFromJSONTyped, ApiDocumentTypeToJSON };
//# sourceMappingURL=ApiDocumentType.js.map
